import { Wizard } from '../../../components/Wizard/Wizard';
import { useStores } from '../../../stores/useStores';
import ChooseCountry from '../ChooseCountryDialog/ChooseCountry';
import { EmailVerification } from '../EmailVerification/EmailVerification';
import { ResponsibleSocialPlay } from '../ResponsibleSocialPlayTerms/ResponsibleSocialPlayTerms';
import SignUpEmailLanding from '../SignUpEmailLanding/SignUpEmailLanding';
import { SignUpOptions } from '../SignUpOptions/SignUpOptions';
import { SignUpPrivacy } from '../SignUpPrivacy/SignUpPrivacy';
import { SignUpRegister } from '../SignUpRegister/SignUpRegister';
import { VerificationSuccess } from '../VerificationSuccess/VerificationSuccess';
import WelcomeBonusDialog from '../WelcomeBonusDialog/WelcomeBonusDialog';

import { DirectSignUpLandingOrder, DirectEmailLandingOrder, SignupWizardOrder } from './constants';
import { SignUpWizardProvider } from './signUpWizard.provider';

// path = /?landing=direct_su
const DirectSignUpLandingComponents = {
  [DirectSignUpLandingOrder.SignUpOptions]: SignUpOptions,
  [DirectSignUpLandingOrder.ResponsibleSocialPlay]: ResponsibleSocialPlay,
  [DirectSignUpLandingOrder.SignUpRegister]: SignUpRegister,
  [DirectSignUpLandingOrder.EmailVerification]: EmailVerification,
  [DirectSignUpLandingOrder.VerificationSuccess]: VerificationSuccess,
  [DirectSignUpLandingOrder.WelcomeBonusDialog]: WelcomeBonusDialog,
  [DirectSignUpLandingOrder.ChooseCountry]: ChooseCountry,
};

// path = /?landing=direct_em
const DirectEmailLandingComponents = {
  [DirectEmailLandingOrder.SignUpEmailLanding]: SignUpEmailLanding,
  [DirectEmailLandingOrder.ResponsibleSocialPlay]: ResponsibleSocialPlay,
  [DirectEmailLandingOrder.EmailVerification]: EmailVerification,
  [DirectEmailLandingOrder.VerificationSuccess]: VerificationSuccess,
  [DirectEmailLandingOrder.WelcomeBonusDialog]: WelcomeBonusDialog,
  [DirectEmailLandingOrder.ChooseCountry]: ChooseCountry,
};

// path = /
const SignupWizardComponents = {
  [SignupWizardOrder.SignUpPrivacy]: SignUpPrivacy,
  [SignupWizardOrder.ResponsibleSocialPlay]: ResponsibleSocialPlay,
  [SignupWizardOrder.SignUpOptions]: SignUpOptions,
  [SignupWizardOrder.SignUpRegister]: SignUpRegister,
  [SignupWizardOrder.EmailVerification]: EmailVerification,
  [SignupWizardOrder.VerificationSuccess]: VerificationSuccess,
  [SignupWizardOrder.WelcomeBonusDialog]: WelcomeBonusDialog,
  [SignupWizardOrder.ChooseCountry]: ChooseCountry,
};

const getSteps = (authorized: boolean, isDirectSignUpLanding: boolean, isDirectEmailLanding: boolean) => {
  if (!authorized && isDirectSignUpLanding) {
    return Object.values(DirectSignUpLandingOrder)
      .filter((value): value is DirectSignUpLandingOrder => typeof value === 'number')
      .map((value) => DirectSignUpLandingComponents[value]);
  }

  if (!authorized && isDirectEmailLanding) {
    return Object.values(DirectEmailLandingOrder)
      .filter((value): value is DirectEmailLandingOrder => typeof value === 'number')
      .map((value) => DirectEmailLandingComponents[value]);
  }

  return Object.values(SignupWizardOrder)
    .filter((value): value is SignupWizardOrder => typeof value === 'number')
    .map((value) => SignupWizardComponents[value]);
};

export default function SignUpWizard() {
  const { authStore } = useStores();

  const steps = getSteps(authStore.authorized, authStore.isDirectSignUpLanding(), authStore.isDirectEmailLanding());

  return (
    <SignUpWizardProvider>
      <Wizard steps={steps} wrapperStyle={{ overflow: 'hidden' }} />
    </SignUpWizardProvider>
  );
}
